import { render, staticRenderFns } from "./EditTravelPolicy.vue?vue&type=template&id=623899e8"
import script from "./EditTravelPolicy.vue?vue&type=script&lang=js"
export * from "./EditTravelPolicy.vue?vue&type=script&lang=js"
import style0 from "./EditTravelPolicy.vue?vue&type=style&index=0&id=623899e8&prod&lang=stylus&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports